// @generated by TypeGen from LogbookApi/TrackApi - DO NOT EDIT

import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { ITracksResponse } from "../LogbookModel/Track"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface TrackApiEndpoints {
  "GET /api/ships/:shipId/cruises/:cruiseId/track": {
    params: { shipId: number; cruiseId: number };
    query: {};
    request: never;
    response: ITracksResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/days/:dayId/track": {
    params: { shipId: number; dayId: number };
    query: {};
    request: never;
    response: ITracksResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/trips/:tripId/track": {
    params: { shipId: number; tripId: number };
    query: {};
    request: never;
    response: ITracksResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const trackApiEndpoints = {
  "GET /api/ships/:shipId/cruises/:cruiseId/track": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "GET /api/ships/:shipId/days/:dayId/track": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "GET /api/ships/:shipId/trips/:tripId/track": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
} as const;

export class TrackApi {
  constructor(private client: ApiClient) {}

  tracks = {
    cruise: (a: ApiArgs<TrackApiEndpoints, "GET /api/ships/:shipId/cruises/:cruiseId/track">) => ({
      call: (): Promise<ITracksResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/cruises/:cruiseId/track", trackApiEndpoints["GET /api/ships/:shipId/cruises/:cruiseId/track"].targets);
        return this.client.call<ITracksResponse>("GET /api/ships/:shipId/cruises/:cruiseId/track", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/cruises/:cruiseId/track", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    day: (a: ApiArgs<TrackApiEndpoints, "GET /api/ships/:shipId/days/:dayId/track">) => ({
      call: (): Promise<ITracksResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/days/:dayId/track", trackApiEndpoints["GET /api/ships/:shipId/days/:dayId/track"].targets);
        return this.client.call<ITracksResponse>("GET /api/ships/:shipId/days/:dayId/track", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/days/:dayId/track", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    trip: (a: ApiArgs<TrackApiEndpoints, "GET /api/ships/:shipId/trips/:tripId/track">) => ({
      call: (): Promise<ITracksResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/trips/:tripId/track", trackApiEndpoints["GET /api/ships/:shipId/trips/:tripId/track"].targets);
        return this.client.call<ITracksResponse>("GET /api/ships/:shipId/trips/:tripId/track", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/trips/:tripId/track", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
  };
}
